import cx from 'classnames';
import React from 'react';

import { type IconProps, StyledIcon } from './Icon.styles';

const Icon: React.FC<IconProps> = ({ numPaths = 2, size, className = '', isDisabled = false, isActive = false, hasFixedStyle = false }) => {
  const spanList = [];

  for (let i = 0; i < numPaths; i += 1) {
    spanList.push(<span key={i} className={`path${i + 1}`} />);
  }

  return (
    <StyledIcon
      className={cx(className, { filled: !isActive, disabled: isDisabled })}
      $numpaths={numPaths}
      $hasfixedstyle={`${Boolean(hasFixedStyle)}`}
      size={size}
    >
      {spanList.map((item) => item)}
    </StyledIcon>
  );
};

export default Icon;
